const NextI18Next = require("next-i18next").default;
const { localeSubpaths } = require("next/config").default().publicRuntimeConfig;

const localeSubpathVariations = {
  none: {},
  foreign: {
    ru: "ru"
  },
  all: {
    en: "en",
    ru: "ru"
  }
};

const options = {
  fallbackLng: "en",
  load: "languageOnly",
  defaultNS: "common",
  debug: false, // process.env.NODE_ENV !== 'production',
  saveMissing: true,
  interpolation: {
    escapeValue: false // not needed for react!!
  },
  react: {
    wait: true,
    useSuspense: false
  }
};

module.exports = new NextI18Next({
  ...options,
  otherLanguages: ["ru"],
  localeSubpaths: localeSubpathVariations[localeSubpaths]
});
